// extracted by mini-css-extract-plugin
export default {"container":"ProductCategory_container__FyNvU","inner":"ProductCategory_inner__dhIEs","category__menu":"ProductCategory_category__menu__zIfut"};